import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../public/icons/excel/form/save_data_64.png'
import _imports_1 from '../../../../../public/icons/excel/form/select_parameters_64.png'
import _imports_2 from '../../../../../public/icons/excel/form/refresh_64.png'
import _imports_3 from '../../../../../public/icons/excel/form/audit_trail_64.png'
import _imports_4 from '../../../../../public/icons/excel/form/add_row_64.png'
import _imports_5 from '../../../../../public/icons/excel/form/delete_row_64.png'
import _imports_6 from '../../../../../public/icons/excel/form/line_item_64.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-8d555e54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  style: {"width":"100%"},
  class: "itemGrid"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "52",
  height: "52"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "52",
  height: "52"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "52",
  height: "52"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  width: "52",
  height: "52"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  width: "52",
  height: "52"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  width: "52",
  height: "52"
}, null, -1))
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  width: "52",
  height: "52"
}, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "d-flex flex-column w-100 p-2"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Save")
], -1))
const _hoisted_14 = { class: "d-flex flex-direction-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_ctx.isBusy)
    ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.showAuditTrail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ValidateSaveData()))
                }, [
                  _hoisted_3,
                  _createElementVNode("div", null, _toDisplayString(_ctx.Localizer.Localize('Save_Data')), 1)
                ]),
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ParametersSelectionRequested = true))
                }, [
                  _hoisted_4,
                  _createElementVNode("div", null, _toDisplayString(_ctx.Localizer.Localize('Parameters')), 1)
                ]),
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.RefreshFormRequested = true))
                }, [
                  _hoisted_5,
                  _createElementVNode("div", null, _toDisplayString(_ctx.Localizer.Localize('Refresh')), 1)
                ]),
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ShowAuditTrail()))
                }, [
                  _hoisted_6,
                  _createElementVNode("div", null, _toDisplayString(_ctx.Localizer.Localize('Audit_Trail')), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["item", { disabled: _ctx.SelectedControl ? !_ctx.SelectedControl.AddRows || _ctx.disableBtn : true }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.RowAction('add')))
                }, [
                  _hoisted_7,
                  _createElementVNode("div", null, _toDisplayString(_ctx.Localizer.Localize('Add_Row')), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["item", { disabled: _ctx.SelectedControl ? !_ctx.SelectedControl.DeleteRows || _ctx.disableBtn : true }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.RowAction('delete')))
                }, [
                  _hoisted_8,
                  _createElementVNode("div", null, _toDisplayString(_ctx.Localizer.Localize('Delete_Row')), 1)
                ], 2),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", null, _toDisplayString(_ctx.Localizer.Localize('Line_Item_Details')), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auditTrail, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass([{'active': i == _ctx.selectedAuditTrailIndex}, 'd-flex justify-content-between']),
                  onClick: ($event: any) => {_ctx.selectedAuditTrailIndex = i;},
                  onDblclick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.OpenAuditTrailItem())),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(item.timestamp.toLocaleDateString()) + " " + _toDisplayString(item.timestamp.toLocaleTimeString()), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(item.userDisplayName), 1)
                  ]),
                  _hoisted_13
                ], 42, _hoisted_12))
              }), 128)),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_CommonButton, {
                  type: _ctx.ButtonType.Default,
                  text: _ctx.Localizer.Localize('Cancel_PascalCase'),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.showAuditTrail=false; _ctx.selectedAuditTrailIndex=-1})
                }, null, 8, ["type", "text"]),
                _createVNode(_component_CommonButton, {
                  type: _ctx.ButtonType.Primary,
                  text: _ctx.Localizer.Localize('Open_PascalCase'),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.OpenAuditTrailItem()))
                }, null, 8, ["type", "text"])
              ])
            ]))
      ]))
}